import React from "react";
import MenuItemLayout from "./menuItemLayout/MenuItemLayout";
import banner from "../../assets/images/intern_banner.png";
import heroMobile from "../../assets/images/intern-mob.png";



interface TitleProps {
  title: string;
  subtitle: string;
}
const WaitingForContentPage: React.FC<TitleProps> = ({
  title,
  subtitle,
}) => {
  
  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title={title}
      subTitle={subtitle}
      urlImage={banner}
    >
      <div style={{minHeight:"100px"}}></div>
    </MenuItemLayout>
  );
};

export default WaitingForContentPage;
